import {
  DecisionActionRequest,
  DecisionActionResult,
  DecisionActivity,
  DecisionDetail,
  DecisionPage,
  NextBestDecision
} from "../../../models/home";
import {
  HomeActivityNarrativeResponse,
  HomeDecisionDetailResponse,
  HomeDecisionPageResponse,
  HomeIaDecisionActionRequest,
  HomeIaDecisionActionResponse,
  HomeNextBestDecisionResponse,
} from "../../../models/home/dtos";
import {
  toActionViewModel,
  toActivityViewModel,
  toAvailableActionsViewModel,
  toDetailItemViewModel,
  toListItemViewModel,
  toQueryViewModel,
  toSummaryViewModel
} from "./decision.adapter.entity-mappers";
import {
  toOptionalActionOutcome,
  toOptionalActionResultType,
  toOptionalReevaluationStatus,
  toOptionalState
} from "./decision.adapter.status-mappers";

export class DecisionAdapter {
  static toPageViewModel(dto: HomeDecisionPageResponse): DecisionPage {
    const items = (dto.items ?? []).map((item) => toListItemViewModel(item));
    const summary = toSummaryViewModel(dto.summary);
    const page = dto.page ?? 1;
    const pageSize = dto.pageSize ?? (items.length || 1);
    const totalItems = dto.totalItems ?? items.length;
    const totalPages = dto.totalPages ?? Math.max(1, Math.ceil(totalItems / pageSize));

    return {
      items,
      summary,
      filters: toQueryViewModel(dto.filters),
      page,
      pageSize,
      totalItems,
      totalPages,
      hasMore: dto.hasMore ?? page < totalPages,
      refreshedAt: dto.refreshedAt ?? undefined
    };
  }

  static toNextBestDecisionViewModel(dto: HomeNextBestDecisionResponse | null | undefined): NextBestDecision | null {
    if (!dto?.decision && !dto?.nextAction && !dto?.summary) {
      return null;
    }

    return {
      decision: dto?.decision ? toListItemViewModel(dto.decision) : null,
      nextAction: toActionViewModel(dto?.nextAction),
      summary: dto?.summary ? toSummaryViewModel(dto.summary) : null
    };
  }

  static toDetailViewModel(dto: HomeDecisionDetailResponse): DecisionDetail {
    return {
      decision: dto.decision ? toDetailItemViewModel(dto.decision) : null,
      activityPreview: DecisionAdapter.toHistoryViewModel(dto.activityPreview),
      relatedDecisionIds: dto.relatedDecisionIds ?? []
    };
  }

  static toHistoryViewModel(
    dto: readonly HomeActivityNarrativeResponse[] | null | undefined
  ): readonly DecisionActivity[] {
    return (dto ?? []).map((item) => toActivityViewModel(item));
  }

  static toActionRequestDto(request: DecisionActionRequest): HomeIaDecisionActionRequest {
    return {
      action: request.action ?? null,
      notes: request.notes ?? null,
      reason: request.reason ?? null,
      assignedToUserId: request.assignedToUserId ?? null,
      snoozedUntil: request.snoozedUntil ?? null,
      waitingUntil: request.waitingUntil ?? null,
      blockedReason: request.blockedReason ?? null,
      missingInformation: request.missingInformation ?? null,
      completionEvidence: request.completionEvidence ?? null,
      endpointTemplate: request.endpointTemplate ?? null,
      httpMethod: request.httpMethod ?? null,
      payloadTemplate: request.payloadTemplate ?? null,
      payload: request.payload ?? null,
      clientTraceId: request.clientTraceId ?? null
    };
  }

  static toActionResultViewModel(dto: HomeIaDecisionActionResponse): DecisionActionResult {
    return {
      decisionId: dto.decisionId ?? "",
      previousState: toOptionalState(dto.previousState),
      newState: toOptionalState(dto.newState),
      action: dto.action ?? undefined,
      actionResultType: toOptionalActionResultType(dto.actionResultType),
      reevaluationStatus: toOptionalReevaluationStatus(dto.reevaluationStatus),
      outcome: toOptionalActionOutcome(dto.outcome),
      refreshHints: dto.refreshHints ?? [],
      success: dto.success ?? false,
      message: dto.message ?? undefined,
      activityId: dto.activityId ?? undefined,
      updatedDecision: dto.updatedDecision ? toDetailItemViewModel(dto.updatedDecision) : null,
      updatedSummary: dto.updatedSummary ? toSummaryViewModel(dto.updatedSummary) : null,
      availableActions: toAvailableActionsViewModel(dto.availableActions),
      idempotencyReplay: dto.idempotencyReplay ?? false,
      isConflict: dto.isConflict ?? false
    };
  }



































}
